import templateUrl from "emun.medialibrary/upload-media-prompt.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import productPicker from "emun.products/picker/product-picker";
import Product from 'emun.shopping/product.model'
import labels from "emun.products/_labels";
import "emun.products/lists/product-list-viewer-table.htm";
import $appConfig from 'servicestack/config'

class controller {
  constructor($scope, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.title = "Media Item";
		$ctrl.labels = labels;
		$ctrl.productSelection = {};
		$ctrl.$appConfig = $appConfig;
		if ($ctrl.options.media) {
			$ctrl.media = $ctrl.options.media;
			$ctrl.bus.send("QueryMediaLibraryJoin.json?Id=" + $ctrl.media.id).then(function(response) {
				$ctrl.productSelection.productIds = [];
				response.data.results.forEach(function(res) {
					$ctrl.productSelection.productIds.push(res.productId);
				});
				$ctrl.loadProducts();
			});
		}

		$ctrl.upload = function($files) {
			if ($files && $files.length) {
			let req = {
				request: {
				productIds: $ctrl.productSelection.productIds
				},
				files: $files
			};

			$ctrl.bus.upload("ImportProductMediaFiles.json", req).then(function(response) {
				$ctrl.media = response.data.media[0];
				$ctrl.$broadcast("$mediaUploaded");
			});
			}
		};  
	}
	addProducts() {
		const $ctrl = this;
		const { productIds = [] } = $ctrl.productSelection;
		productPicker({
			title: "Select products for media file...",
			view: "table",
			viewSelections: productIds.length > 0,
			selected: productIds.reduce(
			(m, id) => Object.assign(m, { [id]: true }),
			{}
			)
		}).then(function(ids) {
			Object.assign($ctrl.productSelection, { productIds: Object.keys(ids) });
			$ctrl.bus.send("ImportProductMediaShare", {
				MediaId: $ctrl.media.id,
				ProductIds: $ctrl.productSelection.productIds
			}).then(function(response) {
				$ctrl.loadProducts();
			});
		});
	}

	loadProducts() {
		const $ctrl = this;
		$ctrl.productsQuery = new AutoQuery({
			url: "QueryProducts.json?IdIn=" + $ctrl.productSelection.productIds.join(","),
			autoLoad: true
		});
	}
	$onClose() {
		const $ctrl = this;
		$ctrl.$dismiss();
	}
}
export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
          controllerAs: "$ctrl",
          size: "lg"
        },
        (options || {}).modal
      )
    ).result;
  }
};
